import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { ProductActionMenu } from "./ProductActionMenu";
import { CategoryAction } from "./CategoryAction"

export const productTabs = [
    { value: "product list", label: "PRODUCT LIST" },
    { value: "add new product", label: "ADD NEW PRODUCT OR UPDATE PRODUCT" },
  ]

export const categoryOptions = [
    { label: "CRM Solutions", value: "CRM Solutions" },
    { label: "CORE ERP", value: "CORE ERP" },
    { label: "CMS", value: "CMS" },
    { label: "Mobile Apps", value: "Mobile Apps" },
    { label: "Documentation", value: "Documentation" },
]

export const initialValues = {
    icon: "",
    title: "",
    description: "",
    url: "",
    access_type: "",
    category: "",
};

export const ProductCatalogListColumns = ()=> (
    [
      {
        field: "icon",
        headerName: "Icon",
        width:80,
        renderCell: (params) => (
            <img
              src={params.value}
              alt="icon"
              style={{ width: 30, height: 30, objectFit: "contain", borderRadius: 4 }}
            />
          ),
      },
      {
        field: "title",
        headerName: "Title",
        flex: 1,
        minWidth:150,
        renderCell: ({ value, id }) => (
            <>
           {<Link underline="none" component={RouterLink} to={`${id}`}>
              {value}
            </Link>}
            </>
          ),
      },
      {
        field: "description",
        headerName: "Description",
        flex: 1,
        minWidth:200,
      },
      {
        field: "url",
        headerName: "URL",
        flex: 1,
        minWidth:150,
        renderCell: ({ value }) => (
          <Link href={value} target="_blank" rel="noopener noreferrer" underline="none">
            {value}
          </Link>
        )
      },
      {
        field: "create_at",
        headerName: "Creation Time",
        flex: 1,
        type: "date",
        minWidth:150,
        renderCell: ({ value }) => (
          <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
            <span>{yearFirstDateTimeFormat(value)}</span>
          </Tooltip>
        ),
      },
      {
        field: "access_type",
        headerName: "Access Type",
        width: 130,
        sortable: false,
        renderCell:(value) => {
          return value.value === 1 ? "Public" : "Private";
        }
      },
      {
        field: "category",
        headerName: "Category",
        width: 130,
        sortable: false,
      },
      {
        field: "Actions",
        width: 70,
        sortable: false,
        renderCell: (params) => (
          <ProductActionMenu productId={params.row.id} />
        ),
      },
    ]
  );
  
export const ProductCategoryListColumns = (refetch) => (
  [
   {
      field: "category",
      headerName: "Category",
      flex: 1,
      minWidth:200,
    },
    {
      field: "Actions",
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <CategoryAction categoryId={params.row.id} refetch={refetch}/>
      ),
    }
  ]
)